import cn from 'classnames';
import LocalizationService from '../service/LocalizationService';

const CatalogItem = (props) => {
    const {
        id, name, badge, link, photo, price, packing, isSlider, amount, in_basket, price_group
    } = props;

    const itemClassname = cn(
        'catalog-item',
        {
            'swiper-slide': isSlider
        }
    );
    const badgeHtml = badge ? ` 
        <div class="catalog-item__label" style="background: ${badge.color}">
            ${badge.name}
        </div>
    ` : '';
    const packingHtml = packing ? `
        <div class="catalog-item__description">${packing}</div>
    ` : '';

    let priceText = '';
    let basketPanel = '';
    if (price && price > 0 && amount && amount > 0) {
        priceText = (price == parseInt(price, 10)) ? `
 <div class="catalog-item__price-container">
 <div class="catalog-item__price-label">
                                        ${price_group}
                                    </div><span class='india-currency-symbol'>₹</span>&nbsp;${price}
</div>
   <div class="catalog-item__price-notice">
                                    Inclusive of all taxes
                                </div>
` : price;
        basketPanel = !in_basket ? `
            <div class="catalog-item-hover">
                <div class="catalog-item-hover-panel">
                    <div class="catalog-item-hover-panel__minus"><div class="catalog-item-hover-panel__minus--image"></div></div>
                    <div class="catalog-item-hover-panel__text" data-product-id="${id}" data-value="1">
                        <span>Add to basket</span><br>
                        <span class="catalog-item-hover-panel__text--count">1</span>
                    </div>
                    <div class="catalog-item-hover-panel__plus"><div class="catalog-item-hover-panel__plus--image"></div></div>
                </div>
            </div>
        ` : `
            <div class="catalog-item-hover">
                <div class="catalog-item-hover-panel catalog-item-hover-panel--narrow">
                    <div class="catalog-item-hover-panel__to-basket">Go to basket</div>
                </div>
            </div>
        `;
    } else {
        priceText = LocalizationService.getByLocale({
            ru: '<small>Ожидает поступления</small>',
            en: '<small>Not available now</small>'
        });
    }

    return `
        <a href="${link}" class="${itemClassname}">
            ${badgeHtml}
            ${basketPanel}
            <div class="catalog-item__image" style="background-image: url('${photo}')"></div>
            <div class="catalog-item__title">${name}</div>
            ${packingHtml}
            <div class="catalog-item__row">
                <div class="catalog-item__price">${priceText}</div>
            </div>
        </a>
    `;
};

export default CatalogItem;
